var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contractor-contact-wrapper" },
    [
      _vm.contacts.length > 0
        ? _c("table", { staticClass: "contractor-contacts" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.itemHeaders, function (header, index) {
                    return _c(
                      "th",
                      {
                        key: "contractor_contact_" + index,
                        class: {
                          "required-flag":
                            _vm.isEditing &&
                            _vm.isPrimary &&
                            !header.notRequireWhenPrimary,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(header.name) + "\n        "
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("th", {
                    class: {
                      "icon-remove": _vm.isEditing,
                      "invite-contractor-user": !_vm.isEditing,
                    },
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.contacts, function (contact, index) {
                return _c(
                  "tr",
                  { key: "contact_" + index },
                  [
                    _c(
                      "td",
                      { staticClass: "contact-name" },
                      [
                        _vm.isEditing
                          ? _vm._l(
                              _vm.getFullnameSorts,
                              function (fullnameObj) {
                                return _c("InputField", {
                                  key: "contact_name_" + fullnameObj.key,
                                  attrs: {
                                    required: _vm.isEditing && _vm.isPrimary,
                                    readonly: !_vm.isEditing,
                                    placeholder: _vm.$t(
                                      "contact.basic." + fullnameObj.label
                                    ),
                                    value: _vm.deep(contact, fullnameObj.value),
                                  },
                                  on: {
                                    updateValue: function (val) {
                                      return _vm.update(
                                        _vm.getUpdatePath(index),
                                        fullnameObj.value,
                                        val
                                      )
                                    },
                                  },
                                })
                              }
                            )
                          : _c("span", {}, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getDisplayName(contact)) +
                                  "\n          "
                              ),
                            ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.otherFields, function (attr, oIndex) {
                      return _c(
                        "td",
                        {
                          key: "other_contact_" + oIndex,
                          staticClass: "contact-phone",
                        },
                        [
                          _c("InputField", {
                            class: {
                              "required-error-highlight":
                                _vm.inputRequireHighlight &&
                                _vm.isSamePhoneNumbers(contact),
                            },
                            attrs: {
                              required: _vm.isEditing && _vm.isPrimary,
                              readonly: !_vm.isEditing,
                              value:
                                _vm.deep(contact, attr) ||
                                (_vm.isEditing ? "" : "--"),
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.update(
                                  _vm.getUpdatePath(index),
                                  attr,
                                  val
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "contact-email",
                        class: { "contact-email-editing": _vm.isEditing },
                      },
                      [
                        _c("InputField", {
                          attrs: {
                            required:
                              _vm.isEditing &&
                              (!!_vm.deep(contact, "email") ||
                                (_vm.isPrimary && !_vm.isSubFromExternal)),
                            readonly: !_vm.isEditing,
                            readonlyAsInput:
                              _vm.isEditing && _vm.isSubFromExternal,
                            inputCheckType: "email",
                            inputTip: _vm.$t("hint.inputTip.email"),
                            pattern: _vm.regex.email,
                            value:
                              _vm.deep(contact, "email") ||
                              (_vm.isEditing ? "" : "--"),
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.update(
                                _vm.getUpdatePath(index),
                                "email",
                                val
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c("td", { staticClass: "icon-remove" }, [
                          _vm.isPrimary
                            ? _c("div", { staticClass: "hold-delete" })
                            : _c("i", {
                                staticClass: "fa fa-times-thin",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeleteConfirm(index)
                                  },
                                },
                              }),
                        ])
                      : _c("td", { staticClass: "invite-contractor-user" }, [
                          _vm.isPrimary &&
                          _vm.deep(contact, "email") &&
                          _vm.canInvite
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.invite()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.invite")))]
                              )
                            : _c("div", { staticClass: "hold-invite" }),
                        ]),
                  ],
                  2
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && !_vm.isPrimary && _vm.contacts.length <= 1
        ? _c(
            "div",
            {
              staticClass: "add-contact",
              on: {
                click: function ($event) {
                  return _vm.toggleContact(_vm.contacts.length)
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("action.addContact")) + "+\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }